module.exports = __webpack_public_path__ + "img/slider2.jpg?00fba529849894fdf1967c1b29f75548";